/* Save to favourites.

   localStorage, keyed by VARIANT id, because a saved thing is a saved
   thing you can buy, not a saved page. One list, read by both the card
   buttons and the /saved page, so there is a single source of truth.

   No compare, no quickview: a wishlist is the only one of the three a
   customer of a six piece collection actually uses. */
(() => {
  'use strict';
  const KEY = 'sadil_saved';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* private mode */ }
    document.dispatchEvent(new CustomEvent('sadil:saved', { detail: { list } }));
  };
  window.sadilSaved = read;

  const paint = (btn, on) => {
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    const label = on ? btn.dataset.unsave : btn.dataset.saveText;
    if (label) btn.setAttribute('aria-label', label);
  };

  const sync = () => {
    const list = read();
    document.querySelectorAll('[data-save]').forEach((b) => paint(b, list.includes(b.dataset.id)));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-save]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();          // the card around it is a link
    const id = btn.dataset.id;
    const list = read();
    const i = list.indexOf(id);
    if (i === -1) list.push(id); else list.splice(i, 1);
    write(list);
    paint(btn, i === -1);
  });

  document.addEventListener('sadil:saved', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
